import React, { useMemo, PropsWithChildren, } from 'react';
import Header from '../../ui/header/Header';
import useLabels, { useAdminLabels } from '../../hooks/useLabels';
import useRibbonMessage from '../../contexts/adaptive/useRibbonMessage';
import useUserInstructionsModal from '../../hooks/useUserInstructionsModal';
import useAdminPermissions from '../../features/permissions/scopes/admin/hooks/useAdminPermissions';
import RibbonMessage from '../../ui/ribbon-message/RibbonMessage';
import { getClassNames } from '../../helpers/classHelpers';
import { useNavigate } from 'react-router-dom';
import { AppRoute } from '../../router/Routing';
import { BaseUIType } from '../../models/UITypes';
import { adminBasePath } from '../../features/dashboards/admin/helpers/routing';
import AppFooter from '../../ui/footer/AppFooter';
import style from './PageLayout.module.scss';
import runtimeConfig from '../../config/runtimeConfig';

type Props = BaseUIType & {
    mainClassName?: string;
};

const PageLayout: React.FC<PropsWithChildren<Props>> = ({ testId, mainClassName, children }) => {
    // Disabled disclaimer since terms api is making the site crash - to be enabled again
    const labels = useLabels();
    const adminLabels = useAdminLabels();
    const { showAdminLink } = useAdminPermissions();

    const navigate = useNavigate();
    const { openModal, renderModal } = useUserInstructionsModal();

    const { ribbonMessage } = useRibbonMessage();

    const userDropdownItems = useMemo(() => {
        return [
            { label: labels.yourProfile, onClick: () => window.open(runtimeConfig.profileUrl, '_blank') },
            { label: labels.informationPageCta, onClick: () => navigate(AppRoute.info), },
            { label: labels.userInstructions, onClick: openModal, },
            { label: adminLabels.admin, onClick: () => navigate(adminBasePath), isHidden: !showAdminLink() }
        ];
    }, [labels.yourProfile, labels.informationPageCta, labels.userInstructions, openModal, showAdminLink, adminLabels.admin, navigate]);

    return (<>
        <div className={getClassNames([style['page-layout'], ''])} data-testid={testId}>
            <div>
                <Header userDropdownItems={userDropdownItems} />
            </div>

            {ribbonMessage && <RibbonMessage {...ribbonMessage} />}

            <main className={getClassNames([mainClassName, style['main-section']])}>
                {children}
            </main>

            <AppFooter onOpenTerms={openModal} />
        </div>

        {renderModal}
    </>);
};

export default PageLayout;
